module.exports = __webpack_public_path__ + "assets/img/btn-detail-0df34a31.png";